export {default as fantasyScreenshot} from './fantasy-screenshot.png';
export {default as tacticsScreenshot} from './tactics-screenshot.png';
export {default as triviaScreenshot} from './trivia-screenshot.png';
